// extracted by mini-css-extract-plugin
module.exports = {"root":"ColorSwatch--root--5z6IU","bg":"ColorSwatch--bg--1HXfI","swatch":"ColorSwatch--swatch--2Ifvq","active":"ColorSwatch--active--1sxxg"};